import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Input = forwardRef(({ title, type = "text", name, value, placeholder, required = false, error, handleChange, ...props }, ref) => {
  if (!placeholder) {
    placeholder = title;
  }
  return (
    <>
      {title && (
        <label className="block mb-2 text-sm font-medium text-gray-900" htmlFor={name}>
          {title}{required ? '*' : ''}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        name={name}
        id={name}
        value={value}
        className="bg-gray-50 border border-gray-300 text-gray-900 transition-all rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2"
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        data-testid={`${name}-input`}
        {...props}
      />
      {error && <p className="text-red-500 text-sm" role="alert" aria-live="polite">{error}</p>}
    </>
  );
});

Input.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

Input.displayName = 'Input';

export default Input;